import * as yup from 'yup';
import { ConsultAttestationEnum, NeuroConsultTypes } from 'utils/enums';

export const getValidationSchema = (attestationValue, consultType) => {
  const isFollowUpPhoneCall = attestationValue === ConsultAttestationEnum.followUpPhoneCall;
  const isFollowUpConsultType = consultType === NeuroConsultTypes.FOLLOW_UP;
  const shouldSkipImpression = isFollowUpPhoneCall || isFollowUpConsultType;
  
  return yup.object().shape({
    impressionPredefined: shouldSkipImpression
      ? yup.array()
      : yup
          .array()
          .min(1, 'Impression is required')
          .required('Impression is required'),
  });
};

export default yup.object().shape({
  impressionPredefined: yup
    .array()
    .min(1, 'Impression is required')
    .required('Impression is required'),
});
